import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Results } from '../constants';
import { PaymentResultScreen } from '../PaymentResultScreen';
import { PaymentScreen } from '../PaymentScreen';

const PaymentStatesComponent = (props) => {
  const {
    isSent, setSent, schoolName, cost, schoolId,
  } = props;

  const [result, setResult] = useState(Results.Success);

  return (
    <>
      {
        isSent
          ? <PaymentResultScreen result={result} />
          : (
            <PaymentScreen
              setResult={setResult}
              setSent={setSent}
              schoolName={schoolName}
              cost={cost}
              schoolId={schoolId}
            />
          )
      }
    </>
  );
};

PaymentStatesComponent.propTypes = {
  schoolName: PropTypes.string.isRequired,
  isSent: PropTypes.bool.isRequired,
  setSent: PropTypes.func.isRequired,
  cost: PropTypes.string.isRequired,
  schoolId: PropTypes.string.isRequired,
};

export { PaymentStatesComponent };
